import { Button, Divider, Flex, VStack } from '@chakra-ui/react'
import { BlockContainer, BlockContent, BlockHeader } from '../components/shared/Block'
import { BsBook, BsHouse } from 'react-icons/bs'
import ManualList from '../components/manual/ManualList'
import ManualViewer from '../components/manual/ManualViewer'
import selectedItemAlertContext from '../context/selectedItemAlertContext'
import { useState } from 'react'
import { Link } from 'react-router-dom'

const Manual = ({ homeLink = false }) => {
    const defaultData = {
        id: 1,
        type: 'doc/manual_user.pdf',
    }
    const [itemData, setItemData] = useState(defaultData)

    return (
        <Flex p={{base:"",md:"40px"}} direction="column" w="full">
            <BlockContainer>
                <BlockHeader title="คู่มือการใช้งานและเอกสารที่เกี่ยวข้อง" icon={BsBook}>
                    {homeLink && <Link to="/"><Button variant="link" leftIcon={<BsHouse />}>กลับหน้าหลัก</Button></Link>}
                </BlockHeader>
                <Divider />
                <BlockContent mt={6}>
                    <VStack w="full" spacing={10}>
                        <selectedItemAlertContext.Provider value={[itemData, setItemData]}>
                            <ManualList />
                            <ManualViewer />
                        </selectedItemAlertContext.Provider>
                    </VStack>
                </BlockContent>
            </BlockContainer>
        </Flex>
    )
}

export default Manual